import {Component, Input, TemplateRef, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'drop-down-modern-content',
    templateUrl: './drop-down-modern-content.component.html',
    styleUrls: ['./drop-down-modern-content.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DropDownModernContentComponent {
    @Input() template: TemplateRef<any>;
}
